export default __webpack_public_path__ + "static/media/kitchen5-beforeB-480w.08854f10.png";